module.exports = __webpack_public_path__ + "img/signe_black_and_white.1fb581b6.jpg";